import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { electOwningCase, Translations } from '../../../utils';
// restClient
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import { Case } from '../../../utils/Models';
import Banner from '../../common/Banner';
import EntitySearchBox from '../../common/EntitySearchBox/';
import NavigationList from '../../common/NavigationList/';
//action Creator
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import {
  createCase,
  createEntity, deleteCase, deleteEntity, newEntities, oldEntities, updateEntityWithCaseId
} from '../../createAcase/actions/actionCreator';
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
import { setTabsStatuses } from '../actions/actionCreator';
//style
import './AddCustomer.css';

class AddCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: {},
      gdocsTermsMessages: {}
    };
  }

  componentWillMount() {
    aemHostClient("/aemData/formData/json_add-entity")
      .then(({ data, status }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
        this.setState({
          pageJson: data
        }, () => { });
      });
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentDidMount() {
    let heading;
    this.setState({
      pageJson: this.props.history.location.state.createCasePageJson
    })
    if (Object.keys(this.props.cases).length > 1) {
      const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
      heading = `${this.props.owningCase.entityName} (+${noOfCasesExcludingRoot} others)`;
    } else {
      heading = this.props.owningCase.entityName;
    }
    this.props.setDarkTitleBarContent(heading, false, null, null, this.props.owningCase);
  }

  componentWillReceiveProps(nextProps) {
    const newlyAddedEntites = this.getEntitiesWithNoCaseIds(nextProps.entities);
    var doesConflictExists = false;
    var doesNegotiatedExists = false;
    newlyAddedEntites.forEach(eId => {
      if (nextProps.entities[eId].status !== 'no_conflicts') {
        doesConflictExists = true;
      }
      if (nextProps.entities[eId].gdocsTerms === 'Negotiated') {
        doesNegotiatedExists = true;
      }
    });
    // for(var entityId in nextProps.entities) {
    //   if(nextProps.entities[entityId].status !== 'no_conflicts') {
    //     doesConflictExists = true;
    //   }
    // }

    if (doesNegotiatedExists && this.state.pageJson !== undefined) {
      this.setState(prevState => {
        return {
          gdocsTermsMessages: {
            ...prevState.gdocsTermsMessages,
            "gdocsTerms_conflicts_msg": {
              "content": this.state.pageJson.par.notification_conflictMessage.message2
            }
          }
        };
      });
    } else if (nextProps.entities && Object.keys(nextProps.entities).length === 0) {
      this.setState({ gdocsTermsMessages: [] });
    } else {
      this.setState(prevState => {
        let _gdocsTermsMessages = { ...prevState.gdocsTermsMessages };
        delete _gdocsTermsMessages.gdocsTerms_conflicts_msg;
        return {
          gdocsTermsMessages: { ..._gdocsTermsMessages }
        };
      });
    }

    if (doesConflictExists && this.state.pageJson !== undefined) {
      let message = this.state.pageJson.par.notification_conflictMessage.message1;
      this.setState(prevState => {
        return {
          messages: {
            ...prevState.messages,
            "case_conflicts_msg": {
              "content": message
            }
          }
        };
      });
    } else if (nextProps.entities && Object.keys(nextProps.entities).length === 0) {
      this.setState({ messages: [] });
    } else {
      this.setState(prevState => {
        let _messages = { ...prevState.messages };
        delete _messages.case_conflicts_msg;
        return {
          messages: { ..._messages }
        };
      });
    }
  }

  backToCaseBody = () => {
    // purging newly added customers from store as user wants to cancel
    const newlyAddedEntites = this.getEntitiesWithNoCaseIds();
    newlyAddedEntites.forEach(entityId => {
      //no need to delete case because case is not created at this moment
      this.props.deleteEntity(entityId);
    });
    this.props.history.push("/case-body");
  }

  checkForCaseConflicts = () => {
    var doesConflictExists = false;
    for (var entityId in this.props.entities) {
      if (this.props.entities[entityId].status !== undefined && this.props.entities[entityId].status !== 'no_conflicts') {
        doesConflictExists = true;
      }
    }
    var newlyAddedEntites = this.getEntitiesWithNoCaseIds();
    return (Object.keys(this.props.entities).length === 0 || newlyAddedEntites.length === 0 || doesConflictExists);
  }

  getEntitiesWithNoCaseIds = (entities) => {
    // will use entities if passed else will use entities in props
    const _entities = entities || this.props.entities;
    return (Object.keys(_entities)).filter(entityId => {
      return _entities[entityId].caseId === undefined;
    });
  }

  prepareAddNewCasesPayload = () => {
    const multiEntity = (Object.keys(this.props.entities)).filter(entityId => {
      return this.props.entities[entityId].caseId === undefined
    }).map(entityId => {
      return {
        partyId: entityId,
        caseId: this.props.entities[entityId].caseId,
        inFlightState: this.props.inFlightCasesState[entityId]
      };
    }) || [];

    let currentGroupIdExist = window.sessionStorage.getItem("currentGroupId");
    if (!currentGroupIdExist) {
      window.sessionStorage.setItem('currentGroupId', Object.values(this.props.cases) && Object.values(this.props.cases)[0] && Object.values(this.props.cases)[0].groupId);
    }
    const groupId = Object.values(this.props.cases) && Object.values(this.props.cases)[0] && Object.values(this.props.cases)[0].groupId || currentGroupIdExist;
    return { multiEntity, groupId }
  }

  toNextpage = () => {
    this.props.blockUi();
    const addNewCasesPayload = this.prepareAddNewCasesPayload();
    if (Object.keys(this.props.entities).length !== 0 && addNewCasesPayload.length !== 0) {
      eapiClient(this.state.pageJson.par.button_addCustomers.apiUrl, {
        method: "POST",
        data: JSON.stringify(addNewCasesPayload)
      })
        .then(({ data, status }) => {
          let _oldEntity = this.props.old_Entities !== undefined ? this.props.old_Entities : [];
          let _newEntity = this.props.new_Entities !== undefined ? this.props.new_Entities : [];
          for (var i = 0; i < data.responseData.length; i++) {
            var { id, entityId, newEntity } = data.responseData[i];
            if (newEntity) {
              _newEntity.push(entityId)
              this.props.newEntities(_newEntity)
            } else {
              _oldEntity.push(entityId)
              this.props.oldEntities(_oldEntity)
            }
            this.props.updateEntityWithCaseId(entityId, id);
            this.props.createCase(new Case(data.responseData[i]));
          }
          //get all tabs status and wait for data to come and then change route
          eapiClient('/cases/' + this.props.owningCase.id + '/tabStatus')
            .then(({ data, status }) => {
              this.props.setTabsStatuses(data.responseData);
              this.props.history.push("/case-body");
              this.props.unBlockUi();
            });
        });
    } else if (Object.keys(this.props.entities).length !== 0) {
      this.props.history.push("/case-body");
      this.props.unBlockUi();
    }
  }

  getSelectedEntity = (selectedEntity) => {
    this.props.createEntity(new Entity(selectedEntity));
  }

  deleteEntity = (entityId) => {
    this.props.deleteEntity(entityId);
    for (var caseId in this.props.cases) {
      if (this.props.cases[caseId].entityId === entityId) {
        this.props.deleteCase(caseId);
      }
    }
  }

  render() {
    let messagesJsx = Object.keys(this.state.messages).map((messageId, index) => (
      <Banner
        key={index}
        bannerType="warning"
      >
        {this.translations(this.state.messages[messageId].content)}
      </Banner>
    ))
    let gdocsTermsMessagesJsx = Object.keys(this.state.gdocsTermsMessages).map((gdocsTermsMessagesId, index) => (<Banner key={index} bannerType="warning">{this.translations(this.state.gdocsTermsMessages[gdocsTermsMessagesId].content)}</Banner>))
    let jsx = (<h3>Loading.....</h3>);
    if (this.state.pageJson) {
      jsx = (
        <div className="selectcustomercontainer">
          <h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextOne.text)}</h5>
          <ul>
            <li><h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextTwo.text).split(',')[0].split('[')[1]}<a href='https://sharepoint.global.hsbc/sites/GLCMDocs/Shared%20Documents/Requesting%20a%20Pack%20Page/GDocs%20Negotiated%20Customer%20List.xlsx'> {this.translations(this.state.pageJson.par.static_text_guidanceTextTwo.text).split(',')[1]}</a>
              {this.translations(this.state.pageJson.par.static_text_guidanceTextTwo.text).split(',')[2]} <a href='https://sharepoint.global.hsbc/sites/GLCMDocs/Shared%20Documents/Requesting%20a%20Pack%20Page/Negotiation%20Process%20-%20Live.pdf' target="_blank">{this.translations(this.state.pageJson.par.static_text_guidanceTextTwo.text).split(',')[3]}</a> {this.translations(this.state.pageJson.par.static_text_guidanceTextTwo.text).split(',')[4].split(']')[0]}</h5></li>
            <li><h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextThree.text1)}<a href='https://sharepoint.global.hsbc/sites/GLCMDocs/GDMPortal/Shared%20Documents/HSBC%20Global%20Documentation%20Pack%20Request%20-%20Live%20(Portal).pdf' target="_blank"> {this.translations(this.state.pageJson.par.static_text_guidanceTextThree.text2)}</a>.</h5></li>
            <li>
              <h5>
                {this.translations(this.state.pageJson.par.static_text_guidanceTextUS.text).split(',')[0].split('[')[1]}&nbsp;
                <a href='https://sharepoint.global.hsbc/sites/GLCMDocs/US%20GPS%20Terms/US%20GPS%20Terms.pdf' target='_blank'>
                  {this.translations(this.state.pageJson.par.static_text_guidanceTextUS.text).split(',')[1]}
                </a>
                {this.translations(this.state.pageJson.par.static_text_guidanceTextUS.text).split(',')[2].split(']')[0]}
              </h5>
            </li>
          </ul>
          <h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextFour.text)}</h5>
          <h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextFive.text1)}</h5>
          <h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextFive.text2)}</h5>
          <h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextFive.text3)}</h5>
          <h5>{this.translations(this.state.pageJson.par.static_text_guidanceTextFive.text4)}</h5>
          <h2>{this.translations(this.state.pageJson.par.page_title_mainTitle.pageHeading)}</h2>
          {this.translations(this.state.pageJson.par.type_ahead_customerSearch.addEntities)}
          <EntitySearchBox
            setSelectedOptions={this.getSelectedEntity}
            AddscustomerTitle={this.translations(this.state.pageJson.par.type_ahead_customerSearch.title)}
            createNewEntityLinkRoute="/case-body/create-new-entity"
            maxLength={this.state.pageJson.par.type_ahead_customerSearch.maxChars || 60}
            lang={this.props.lang}
            addText={this.state.pageJson.par.type_ahead_customerSearch.addText}
          />
          <div className="banners-area">
            {messagesJsx}
          </div>
          <div className="banners-area">
            {gdocsTermsMessagesJsx}
          </div>
          <NavigationList
            cases={this.props.cases}
            entities={this.props.entities}
            history={this.props.history}
            statusOption={this.state.pageJson.par.navigation_list_customerList.status}
            gdocsTerms1={this.state.pageJson.par.navigation_list_customerList.gdocs_Terms1}
            gdocsTerms2={this.state.pageJson.par.navigation_list_customerList.gdocs_Terms2}
            listtype="caseBodyAddNewCustomersList"
            deleteEntity={this.deleteEntity}
            pageReferer={'entitiesPage'}
          />
          <div id="btnwrapperid" className={this.props.entities.length === 0 ? 'btnWrapper' : 'btnWrapper setbtnpadd'}>
            <div className="rightbtn">
              <button
                onClick={this.backToCaseBody}
                className={'btn btn-primary btnmrg'}
              >
                {this.translations(this.state.pageJson.par.button_cancel.text)}
              </button>
              <button
                onClick={this.toNextpage}
                disabled={this.checkForCaseConflicts()}
                className={this.checkForCaseConflicts() ? 'btn btn-primary btndisable' : 'btn btn-primary btnbg'}
              >
                {this.translations(this.state.pageJson.par.button_addCustomers.text)}
              </button>
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
        </div>);
    }
    return (
      <div className="add-customer-from-case-body-container">
        {jsx}
      </div>
    );
  }
}

class Entity {
  constructor({ entityId, entityName, status, gdocsTerms, countryOfFormation }) {
    this.id = entityId;
    this.entityId = entityId;
    this.entityName = entityName;
    this.cof = countryOfFormation;
    this.caseId = undefined;
    this.status = status;
    this.gdocsTerms = gdocsTerms;
  }
}


const mapStateToProps = state => {
  return {
    cases: state.cases,
    entities: state.entities,
    inFlightCasesState: state.inFlightCasesState,
    owningCase: electOwningCase(state.cases),
    lang: state.lang,
    new_Entities: state.newEntities,
    old_Entities: state.oldEntities
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createCase: _case => {
      dispatch(createCase(_case))
    },
    createEntity: _entity => {
      dispatch(createEntity(_entity))
    },
    updateEntityWithCaseId: (entityId, caseId) => {
      dispatch(updateEntityWithCaseId(entityId, caseId))
    },
    deleteEntity: _entity => {
      dispatch(deleteEntity(_entity))
    },
    deleteCase: caseId => {
      dispatch(deleteCase(caseId))
    },
    setTabsStatuses: (tabStatuses) => {
      dispatch(setTabsStatuses(tabStatuses));
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args));
    }, newEntities: newEntity => {
      dispatch(newEntities(newEntity))
    },
    oldEntities: oldEntity => {
      dispatch(oldEntities(oldEntity))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomer);



// WEBPACK FOOTER //
// ./src/components/CaseBody/CustomerDetails/AddCustomer.js